import { DateTime } from 'luxon';
import { PayoutPeriodLabel } from '@gbr-monorepo/interfaces';
import { FiscalHalfYear, getFiscalHalfYear, getFiscalHalfYearFromInterval } from '@gbr-monorepo/application/utils';

const TRANSLATION_KEY_BASE = 'seasons.season-details.payout-periods';

/**
 * Builds the fiscal half year translation object (`key` + interpolation
 * `params`) rendered as e.g. `H1 FY 24/25`.
 */
export class PayoutPeriodOperations {
    public static getLabelFromDate(date: DateTime): PayoutPeriodLabel {
        return this.toLabel(getFiscalHalfYear(date));
    }

    public static getLabelFromInterval(interval: string): PayoutPeriodLabel {
        return this.toLabel(getFiscalHalfYearFromInterval(interval));
    }

    public static toLabel(fiscalHalfYear: FiscalHalfYear | null): PayoutPeriodLabel {
        if (!fiscalHalfYear) {
            return { key: '', params: { fiscalYearStart: '', fiscalYearEnd: '' } };
        }

        return {
            key: `${TRANSLATION_KEY_BASE}.${fiscalHalfYear.half.toLowerCase()}`,
            params: {
                fiscalYearStart: this.toTwoDigitYear(fiscalHalfYear.fiscalYearStart),
                fiscalYearEnd: this.toTwoDigitYear(fiscalHalfYear.fiscalYearEnd)
            }
        };
    }

    private static toTwoDigitYear(year: number): string {
        return `${year % 100}`.padStart(2, '0');
    }
}
